import { CS } from "../../../../../base/utils/styler";

export const editorStyle: CS = {
    width: '100%',
    height: '300px',
    marginBottom: '10px',
}

export const contentsSyle: CS = {
    display: 'grid',
    gridTemplateColumns: '6fr 4fr',
    gridGap: '1rem',
    flexDirection: 'row',
    width: '100%',
}

export const viewStyle: CS = {
    direction: 'rtl',
}

export const submitStyle: CS = {
    zIndex: '1000',
    margin: '20px',
    minWidth: '200px',
    textAlign: 'center',
    position: 'fixed',
    bottom: '10px',
    left: '10px',
}